import { render, staticRenderFns } from "./TemplateSentToApproval.vue?vue&type=template&id=b055bdde&scoped=true&"
import script from "./TemplateSentToApproval.vue?vue&type=script&lang=ts&"
export * from "./TemplateSentToApproval.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSentToApproval.vue?vue&type=style&index=0&id=b055bdde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b055bdde",
  null
  
)

export default component.exports